<template>
  <div class="row">
    <div class="col-12">
      <div class="card mb-4">
        <div class="card-header pb-0">
          <div class="row">
            <div class="col-6">
              <h6 class="mb-0">Billers</h6>
            </div>
          </div>
        </div>
        <hr class="mx-3" style="border-top: 1px solid !important" />

        <biller-header />
        <hr class="horizontal dark mt-3">
        <biller-list />
      </div>
    </div>
  </div>
</template>

<script>
import bilerHeader from "./components/header.vue";
import billerList from "./components/billerList.vue";

export default {
  components: {
    "biller-header": bilerHeader,
    "biller-list": billerList,
  },
};
</script>

<style>
</style>